<template>
	<div class="template-messages-list">

		<div class="buttons">
			<vs-button @click="activePrompt = true" color="success"> {{ $t('add') }} </vs-button>
		</div>

		<vx-card class="my-8">
			<div class="tab-text ">
				<vs-table max-items="10" pagination :data="works">
					<template slot="thead">
						<vs-th v-for="fil in field" :style="'width:' +fil.width" :class="{'justify-center': fil.align && fil.align === 'center'}">
							{{ fil.title }}
						</vs-th>
					</template>

					<template slot-scope="{ data }">
						<vs-tr :key="indextr"  v-for="(tr, indextr) in data">
							<template v-for="fil in field">
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-if="fil.field === 'name_ru'" >
										{{ tr.name_ru }}
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-if="fil.field === 'name_de'" >
										{{ tr.name_de }}
								</vs-td>

								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'actions'">
									<div class="flex justify-center">
										<vs-button
											size="small"
											color="#626262"
											type="flat"
											icon-pack="feather"
											@click="editModel = JSON.parse(JSON.stringify(tr));activePromptEdit = true"
											icon="edit"
										>
											<feather-icon icon="EditIcon"></feather-icon>
										</vs-button>
										<vs-button
											size="small"
											color="#626262"
											type="flat"
											icon-pack="feather"
											@click='editModel = tr;$vs.dialog({
												color: "danger",
												title: $t("confirmDeletion"),
												acceptText: $t("delete"),
												text: $t("doYouWantToDelete") + " \"" + tr.name_de + "\"",
												accept: removeChatTemplates,
											});'
											icon="edit"
										>
											<feather-icon icon="Trash2Icon"></feather-icon>
										</vs-button>
									</div>
								</vs-td>
							</template>

						</vs-tr>
					</template>
				</vs-table>
			</div>
		</vx-card>
		<vs-prompt
			@cancel="date = ''"
			@accept="editChatTemplate"
			:active.sync="activePromptEdit"
			:title="$t('changeTemplateAnswer')"
			:acceptText="$t('save')"
			:cancelText="$t('cancel')"
		>
			<div class="con-exemple-prompt mb-4">
				<div class="vs-component vs-con-input-label vs-input vs-input-primary">
					<label class="vs-input--label">{{ $t('name_ru') }}</label>
					<div class="vs-con-input"></div>
					<vs-input
						v-model="editModel.name_ru"
						name="name_ru"
						v-validate="'required|min:3'"
					/>
				</div>
				<span class="text-danger text-sm">{{ errors.first("name_ru") }}</span>
            </div>

            <div class="con-exemple-prompt mb-3">
				<div class="vs-component vs-con-input-label vs-input vs-input-primary">
					<label class="vs-input--label">{{ $t('name_de') }}</label>
					<div class="vs-con-input"></div>
					<vs-input
						v-model="editModel.name_de"
						name="name_de"
						v-validate="'required|min:3'"
					/>
				</div>
				<span class="text-danger text-sm">{{ errors.first("name_de") }}</span>
			</div>

		</vs-prompt>
		<vs-prompt
			@cancel="date = ''"
			@accept="createChatTemplate"
			:active.sync="activePrompt"
			:title="$t('addAnswer')"
			:acceptText="$t('save')"
			:cancelText="$t('cancel')"
		>
			<div class="con-exemple-prompt mb-4">
				<div class="vs-component vs-con-input-label vs-input vs-input-primary">
					<label class="vs-input--label">{{ $t('name_ru') }}</label>
					<div class="vs-con-input"></div>
					<vs-input
						v-model="name_ru"
						name="name_ru"
						v-validate="'required|min:3'"
					/>
				</div>
				<span class="text-danger text-sm">{{ errors.first("name_ru") }}</span>
			</div>

			<div class="con-exemple-prompt mb-3">
				<div class="vs-component vs-con-input-label vs-input vs-input-primary">
					<label class="vs-input--label">{{ $t('name_de') }}</label>
					<div class="vs-con-input"></div>
					<vs-input
						v-model="name_de"
						name="name_de"
						v-validate="'required|min:3'"
					/>
				</div>
				<span class="text-danger text-sm">{{ errors.first("name_de") }}</span>
			</div>

		</vs-prompt>
	</div>
</template>

<script>
import notifier from '../mixins/notifier';
// import { VueEditor } from "vue2-editor";

export default {
	name: "chatTemplates",
	mixins: [notifier],
	data() {
		return {
			nameRu: '',
			message: '',

			activePrompt: false,
			activePromptEdit: false,
			popupActiv: false,
			subjects: [],
			works: [],
			editModel: {}
		};
	},
    components: {
        // VueEditor,
    },
	methods: {
		short: (str, maxlen) => str.length <= maxlen ? str : str.slice(0, maxlen) + ' ...',
		async removeChatTemplates(){
			try {

				await this.$http.post("/admin/chat-template/delete/"+this.editModel.id);

				this.notifySuccess(this.$t('deletedSuccessfully'))
				this.editModel = {};
				this.getChatTemplatesList();

			} catch (e) {
				this.notifyError(e.message);
			}
		},
		async editChatTemplate(id) {
			try {
				let validator = await this.$validator.validateAll();
				if(!validator) return this.activePromptEdit = true;
				let formData = {
					"name_ru": this.editModel.name_ru,
					"name_de": this.editModel.name_de,
				}
				await this.$http.post("/admin/chat-template/update/"+this.editModel.id,formData);

				this.notifySuccess(this.$t('changedSuccessfully'));
				this.editModel = {};
				this.activePromptEdit = false;
				this.getChatTemplatesList();

			} catch (e) {
				this.notifyError(e.message);
			}
		},
		async createChatTemplate() {
			try {
				let validator = await this.$validator.validateAll();
				if(!validator) return this.activePrompt = true;
				let formData = {
					"name_ru": this.name_ru,
					"name_de": this.name_de,
				}
				await this.$http.post("/admin/chat-template/create",formData);

				this.notifySuccess(this.$t('exchange.acceptText'));
				this.name_ru = "";
				this.name_de = "";
				this.popupActiv = false;
				this.getChatTemplatesList();

			} catch (e) {
				this.notifyError(e.message);
			}
		},
		deepFind(obj, path) {
			if (!path) return "";
			let paths = path.split("."),
				current = obj,
				i;

			for (i = 0; i < paths.length; ++i) {
				if (current[paths[i]] === undefined) {
					return undefined;
				} else {
					current = current[paths[i]];
				}
			}
			return current;
		},
		async getChatTemplatesList() {
			try {
				this.works = (
					await this.$http.get("/admin/chat-template")).data.data;
			} catch (e) {
				this.$vs.notify({
					title: "Error",
					text: e.message,
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "danger",
				});
			}
		},
	},
	created() {
		this.field = [
			{
				field: "name_ru",
				title: this.$t('name_ru'),
				width: '45%',
			},
			{
				field: "name_de",
				title: this.$t('name_de'),
				width: '45%',
			},
			{
				field: "actions",
				title: this.$t("actions"),
				align: 'center',
				width: '10%',
			},
		];
	},
	async mounted() {
		this.getChatTemplatesList();
	},
};
</script>

<style scoped lang="scss">
@import "../assets/scss/vuexy/variables.scss";
@import "../assets/scss/vuexy/functions.scss";
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}
.inputInTable {
	border: 0;
	resize: none;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}

.buttons {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	@media screen and (max-width: 375px) {
		button {
			margin: 5px 0;
		}
	}
}
.justify-center .vs-table-text{
	justify-content: center;
}
.vs-checkbox-default{
	flex-shrink: 0;
}
.vs-tabs--content {
	padding: 0;
	margin-top: 10px;
}

.vs-con-table .vs-con-tbody {
	border: 0;
	background-color: transparent;
}
.con-exemple-prompt {
	.append-text {
		height: 2.7rem;
	}
	.vs-button {
		border-left: 0;
	}
	.vx-input-group-append {
		align-items: flex-end;
	}
	.vs-input {
		width: 100%;
		textarea {
			resize: none;
		}
	}
}

.vs-table {
	margin-top: 10px;

	tr {
		border-top: 1px solid #cfcfcf;

		&:last-child {
			border-bottom: 1px solid #cfcfcf;
		}
	}
}
.con-vs-tabs .con-slot-tabs{
	overflow: visible;
}
.task {
	background-color: #3ac47d;
	border-radius: 10px;
	padding: 4px 10px;
	color: white;
}
.counter {
	display: inline-block;
	padding: 5px;
	border-radius: 100%;
	font-weight: 600;
	width: 20px;
	height: 20px;
	font-size: 0.7rem;
	border: 1px solid #cfcfcf;
	display: flex;
	align-items: center;
	justify-content: center;
	line-height: 1;

	&.warn {
		background-color: #f0ad4e;
		color: white;
		border-color: #f0ad4e;
	}
}
.viewTask {
	.vs-popup--title h3 {
		color: $primary;
	}
	.vs-popup--content {
		padding: 0;
	}
	table {
		width: 100%;
		td {
			padding-bottom: 4px;
		}
	}
	.body {
		padding: 1rem;
		table {
			margin-left: -2px;
		}
		p {
			padding-top: 10px;
			font-size: rem(14px);
		}
	}
	.footer {
		border-top: 1px solid rgba(0, 0, 0, 0.05);
		padding: 0.5rem 1rem;
		display: flex;
		justify-content: flex-end;
		button {
			margin-left: 10px;
		}
	}
}
.filter {
	border-bottom: 1px solid #e5e5e5;
	padding-bottom: 1rem;
	padding-top: 0.5rem;
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	.date {
		display: flex;
		align-items: center;
	}
	.vx-input-group .vx-input-group-default .vs-input {
		width: 150px;
	}
	.vx-input-group {
		margin-right: 20px;
	}
	.search .vs-icon {
		height: 100%;
		width: 35px;
		background: $primary;
		position: absolute;
		top: 0;
		right: 0;
		color: white !important;
		display: flex;
		align-items: center;
		justify-content: center;
		border-top-right-radius: 4px;
		border-bottom-right-radius: 4px;
		font-size: 22px;
	}
	.search .vs-con-input-label {
		width: 270px;
	}
}
.template-messages-list {
	.buttons {
		justify-content: flex-end;
	}
	.button-task {
		border-radius: 22px;
		padding: 0.25rem 0.7rem !important;
	}
}
.con-vs-dialog .vs-dialog  {
	width: 100% !important;
	max-width: 800px !important;
}
.set-ticket-done__controls {
	text-align: right;
}
.tox {
	z-index: 999992 !important;
}
.tox-tiered-menu{
	z-index: 999993 !important;
}
.tox-menu {
	z-index: 999994 !important;
}

</style>
